// extracted by mini-css-extract-plugin
export default {"warpper":"questionType_warpper__dgiO1","select":"questionType_select__i9miG","errorText":"questionType_errorText__exinO","required":"questionType_required__FADIb"};